import { LOCATION_INITIALIZED } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { lastValueFrom } from 'rxjs';

import { LocaleEnum } from '../openapi/models';
import { LoggerService } from '../services/logger.service';

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}

export function ApplicationInitializerFactory(translate: TranslateService, injector: Injector, logger: LoggerService) {
	return async () => {
		await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
		const defaultLang = LocaleEnum.Hu;
		translate.addLangs(Object.values(LocaleEnum));
		const currentLang = localStorage.getItem('currentLang') || defaultLang;
		translate.setDefaultLang(currentLang.toLocaleLowerCase());
		localStorage.setItem('currentLang', currentLang);
		try {
			await lastValueFrom(translate.use(currentLang.toLocaleLowerCase()));
		} catch (err) {
			logger.log('translation.config.ts', 'ApplicationInitializerFactory', err);
		}
	};
}
